import { render, staticRenderFns } from "./driverChannelData.vue?vue&type=template&id=c7ccd514&scoped=true"
import script from "./driverChannelData.vue?vue&type=script&lang=js"
export * from "./driverChannelData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ccd514",
  null
  
)

export default component.exports